import * as api from 'utils/resources/rw-social-media.api';
import actionTypes from '../action-types';

export const downloadPosterRequest = () => ({
  type: actionTypes.DOWNLOAD_POSTER_REQUEST,
  error: { poster: false },
});

export const downloadPosterSuccess = () => ({
  type: actionTypes.DOWNLOAD_POSTER_SUCCESS,
});

export const downloadPosterFailure = () => ({
  type: actionTypes.DOWNLOAD_POSTER_FAILURE,
  error: { poster: true },
});

export const downloadPoster = (params) => async (dispatch) => {
  try {
    dispatch(downloadPosterRequest());

    const printables = await api.downloadPoster(params);

    const { data } = await printables.promise;

    window.saveAs(data, 'poster.pdf');

    dispatch(downloadPosterSuccess());
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('DOWNLOAD_POSTER', error);
    dispatch(downloadPosterFailure());
  }
};

export const fetchPosterUrlRequest = () => ({
  type: actionTypes.FETCH_POSTER_URL_REQUEST,
  error: { posterUrl: false },
});

export const fetchPosterUrlSuccess = (url) => ({
  type: actionTypes.FETCH_POSTER_URL_SUCCESS,
  url,
});

export const fetchPosterUrlFailure = () => ({
  type: actionTypes.FETCH_POSTER_URL_FAILURE,
  error: { posterUrl: true },
});

export const fetchPosterUrl = (params) => async (dispatch) => {
  try {
    dispatch(fetchPosterUrlRequest());

    const url = await api.fetchPosterUrl(params);

    dispatch(fetchPosterUrlSuccess(url));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('FETCH_POSTER_URL', error);
    dispatch(fetchPosterUrlFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/actions/rw-social-media/rw-social-media.actions.js